import { Button, Inline } from "@generalapplications/ui";

import {
  RevealGroup,
  RevealItem,
} from "@/app/common/components/composite/motion/RevealGroup";
import { formatText } from "@/app/common/functions/format/formatText";

export type RelatedLinkListProps = {
  items: readonly { label: string; href: string }[];
  ariaLabel?: string;
};

// Related records are lateral navigation, so they deliberately use a quiet
// link treatment rather than the directional service-chip treatment.
export function RelatedLinkList({ items, ariaLabel }: RelatedLinkListProps) {
  return (
    <RevealGroup>
      <Inline as="ul" aria-label={ariaLabel} wrap gap="sm">
        {items.map((item) => (
          <RevealItem as="li" key={item.label}>
            <Button href={item.href} variant="outline" size="xl" weight="bold">
              {formatText(item.label)}
            </Button>
          </RevealItem>
        ))}
      </Inline>
    </RevealGroup>
  );
}
